import { useUser } from '~/@biz_account/useUser/useUser'
import { CompanyRegistrationForm } from '../../company-confirmation/_layout/CompanyConfirmationForm'
import { useCompanyProfile } from '~/@pages_account-settings/profile/company-info/useCompanyProfile'
import { Button } from '~/shadcn/ui/button/button'

function CompanyCompletion() {
  const { reloadUser } = useUser()
  const {
    updateCompanyDataMutation,
    isRequestingUpdateCompanyData,
    updateCompanyDataError,
  } = useCompanyProfile()
  return (
    <CompanyRegistrationForm
      error={updateCompanyDataError}
      onSubmit={(company) => {
        updateCompanyDataMutation(
          { company },
          {
            onSuccess: reloadUser,
          }
        )
      }}
      isRequesting={isRequestingUpdateCompanyData}
      CancelButton={
        <Button variant="outline" type="button" onClick={reloadUser}>
          Preskočiť
        </Button>
      }
    />
  )
}

export { CompanyCompletion }
